/** @format */

import React, { useState } from 'react';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { history } from '../../core/history';
import { useDispatch } from 'react-redux';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { platformGroupsConstants } from '../../modules/platformGroups/reducers';
import { UserPermissionGroupModify } from './UserPermissionGroupModify';
import PlatformUserDefinedRolesInterface from '../../interfaces/platform/PlatformUserDefinedRolesInterface';
import { configDefault } from '../../core/config';
import { DateHelperTs } from '../../helpers/DateHelperTs';
import { NotificationHelper } from '../../helpers/NotificationHelper';

export const UserPermissionGroupAdd = (): React.ReactElement => {
    const dispatch = useDispatch();
    const resellerId = window.sessionStorage.getItem('platformResellerId');

    const [checkedElements, setCheckedElements] = useState<Array<string>>([]);

    const savePermissionGroup = (outputObject: any): void => {
        if (!resellerId) {
            return;
        }

        if (!outputObject.mainname) {
            return;
        }

        if (outputObject.ttlToken) {
            outputObject.ttlToken = parseInt(outputObject.ttlToken);
        } else {
            outputObject.ttlToken = 1800;
        }

        if (outputObject.accountExpiration) {
            outputObject.accountExpiration = parseInt(outputObject.accountExpiration);
        }

        if (!Number.isInteger(outputObject.accountExpiration)) {
            NotificationHelper.notifyError('permission_groups:err.password_expiration_not_int', dispatch);
            return;
        }

        if (outputObject.accountExpiration <= 0) {
            NotificationHelper.notifyError('permission_groups:err.password_expiration_short', dispatch);
            return;
        }

        outputObject.params = JSON.stringify(checkedElements);
        outputObject.createdAt = DateHelperTs.getCurrentDateTime();

        const itemLoaders = new ItemLoaders(dispatch);
        itemLoaders.postWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_user_defined_roles', configDefault.PLATFORM_API_PREFIX)),
            platformGroupsConstants.ADD,
            outputObject,
            (data: PlatformUserDefinedRolesInterface): void => {
                const redirectUri = FormGeneralHelper.getRouteUrl('/user-permission-group-edit/' + data.id);
                // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                // @ts-ignore
                history.push(redirectUri);
            },
            {
                propagateDataToCallback: true,
                dispatchAfterCallback: false,
                dispatchErrorAfterCallback: true,
            }
        );
    };

    return (
        <UserPermissionGroupModify
            resellerId={resellerId}
            savePermissionGroup={savePermissionGroup}
            checkedElements={checkedElements}
            setCheckedElements={setCheckedElements}
        />
    );
};
